export const ALLOWED_TAGS = [
  'tutorial', 'easy', 'hard', 'challenge',
  'real', 'complex', 'mixed', 'portal',
  'sine', 'cosine', 'tangent', 'polar',
  'music-heavy', 'precision', 'exploration',
  'remix', 'showcase',
] as const;

export type AllowedTag = typeof ALLOWED_TAGS[number];

export function isAllowedTag(tag: string): tag is AllowedTag {
  return (ALLOWED_TAGS as readonly string[]).includes(tag);
}
